import React from "react";
import Infobox from "../../utils/Infobox.tsx";
import Reviews from "./Reviews.tsx";
import Man from "../../../assets/testimonials/man.png";
import Pierre from "../../../assets/testimonials/pierre.webp";
import StrapiCircle from "../../../assets/logo/strapi-circle.png";

export default function Testimonials() {
  const reviews = [
    {
      name: "Alex J., Lead Developer at SecureWeb Solutions",
      rating: 5,
      review:
        "Implementing the MFA plugin for our Strapi CMS was a game-changer. The no-code setup made integration seamless, and now we have peace of mind knowing our backend is secure with multiple authentication options. It's a must-have for any developer looking to enhance security!",
    },
  ];

  return (
    <div className="py-20 container col-xxl-12 w-75 mx-auto">
      <div className="row">
        <div className="col-md-6">
          <Infobox
            info={{
              title: "Ready to secure your Strapi CMS?",
              description:
                "Experience the future of Strapi security with our multi-factor authentication plugin. Designed for developers, built for simplicity—get started today with a seamless setup and cutting-edge protection for your CMS.",
              rating: 5,
              button: "Try Headlockr now",
              link: { to: "#pricing", text: "View pricing" },
            }}
          />
        </div>
        <div className="col-md-6 my-10 my-md-0">
          <div className="bg-primary p-2 pt-4 rounded-4 position-relative">
            <img
              src={Pierre}
              alt="Pierre"
              className="img-fluid rounded-circle position-absolute start-50 translate-middle"
              style={{
                objectFit: "cover",
                width: "100px",
                height: "100px",
                top: "0",
              }}
            />

            <h5 className="mt-2 fw-bold">
              <p
                className="text-tertiary display-3"
                style={{
                  fontSize: "3rem",
                  lineHeight: "0.2",
                  marginBottom: -8,
                }}
              >
                “
              </p>
              HeadLockr is the extra security layer your Strapi project needs to
              support Multi-Factor Authentication
            </h5>

            <div className="d-flex align-items-center mt-2">
              <img
                src={StrapiCircle}
                alt="Strapi"
                width={50}
                className="rounded-circle d-inline-block me-2"
              />

              <div className="d-flex flex-column">
                <p className="text-tertiary mb-0">Pierre Burgy</p>
                <p className="mb-0">CEO, Strapi</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        alt="man"
        style={{
          width: "300px",
          height: "auto",
          position: "absolute",
          left: "50%",
          bottom: "150px",
          transform: "translate(-50%, 50%)",
        }}
        src={Man}
      />
    </div>
  );
}
